export default __webpack_public_path__ + "static/media/016-hostel.e2e4ba3f.svg";